import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../ProfileCommon/Breadcrumb";
import privacyPolicySections from "./../../../../contanst/privacyPolicySections.json";
import LoadingCommon from "../../../../components/common/LoadingStatus/LoadingCommon";
import FooterContact from "../../../../components/Footer/FooterContact";
const DataProtectionPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
      <LoadingCommon statusLoading={isLoading} />
        <div className="flex flex-col gap-2 flex-1 px-[30px] pb-[120px]">
          <Breadcrumb
            classNameTitle={"text-[#333333] mb-4"}
            breadCrumbTiltle={t("support.dataProtectionPolicy")}
            onClickBack={() =>
              navigate("/profile/support", {
                state: { direction: -1 },
                replace: false,
              })
            }
          />
          {privacyPolicySections.map((item, index) => (
            <div key={index} className="mb-2">
              <h3 className={"text-[#333333] text-sm font-bold"}>
                {index + 1}. {item.title}
              </h3>
              <div className="pl-[13px]">
                <span className="text-[#333333] text-sm font-normal ">
                  {item.content}
                </span>
              </div>
            </div>
          ))}
        </div>
      <FooterContact className={"!bg-white"} />
    </div>
  );
};

export default DataProtectionPolicy;
